(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aaronya-deserve-colorways"] && !Shopify.designMode) return;
  try {
    class AaronyaProductColorways extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      const trigger = this.querySelector('[data-aaronya-colorways-toggle]');
      const overflow = this.querySelector('[data-aaronya-colorways-overflow]');
      const moreLabel = this.querySelector('[data-aaronya-more-label]');
      const lessLabel = this.querySelector('[data-aaronya-less-label]');

      if (!trigger || !overflow) return;

      trigger.addEventListener('click', () => {
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', String(willOpen));
        overflow.setAttribute('aria-hidden', String(!willOpen));
        overflow.classList.toggle('is-open', willOpen);

        if (moreLabel) moreLabel.hidden = willOpen;
        if (lessLabel) lessLabel.hidden = !willOpen;
      });
    }
  }

  if (!customElements.get('aaronya-product-colorways')) {
    customElements.define('aaronya-product-colorways', AaronyaProductColorways);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aaronya-room-offer"] && !Shopify.designMode) return;
  try {
    class AaronyaRoomOffer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.dialog = this.querySelector('[data-room-offer-dialog]');
      this.steps = Array.from(this.querySelectorAll('[data-room-offer-step]'));
      this.email = this.querySelector('[data-room-offer-email]');
      this.tags = this.querySelector('[data-room-offer-tags]');
      this.selection = this.querySelector('[data-room-offer-selection]');
      this.dismissKey = 'aaronya-room-offer-dismissed-at';
      this.successKey = 'aaronya-room-offer-subscribed-at';
      this.sessionKey = 'aaronya-room-offer-shown';
      this.triggered = false;

      if (!this.dialog) return;

      this.querySelectorAll('[data-room-choice]').forEach((button) => {
        button.addEventListener('click', () => this.chooseRoom(button.dataset.roomChoice));
      });

      this.querySelector('[data-room-offer-back]')?.addEventListener('click', () => {
        this.showStep('room');
      });

      this.querySelectorAll('[data-room-offer-close]').forEach((button) => {
        button.addEventListener('click', () => this.rememberDismissal());
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeOffer();
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
      });

      this.querySelector('[data-room-offer-copy]')?.addEventListener('click', (event) => {
        this.copyCode(event.currentTarget);
      });

      if (this.querySelector('[data-room-offer-posted]')) {
        this.writeStorage(this.successKey, Date.now());
        this.showStep('success');
        this.open();
        return;
      }

      if (this.querySelector('[data-room-offer-errors]')) {
        this.showStep('email');
        this.open();
        return;
      }

      if (!this.isEligible()) return;

      const delay = Number(this.dataset.delay) || 7000;
      this.openTimer = window.setTimeout(() => this.open(), delay);
      this.scrollHandler = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.3) {
          this.open();
        }
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      window.removeEventListener('scroll', this.scrollHandler);
    }

    isEligible() {
      const previewParams = new URLSearchParams(window.location.search);
      if (previewParams.get('aaronya_offer_preview') === '1') return true;

      if (this.readStorage(this.sessionKey)) return false;

      const now = Date.now();
      const dismissDays = Number(this.dataset.dismissDays) || 3;
      const successDays = Number(this.dataset.successDays) || 30;
      const dismissedAt = Number(this.readStorage(this.dismissKey)) || 0;
      const subscribedAt = Number(this.readStorage(this.successKey)) || 0;

      if (dismissedAt && now - dismissedAt < dismissDays * 86400000) return false;
      if (subscribedAt && now - subscribedAt < successDays * 86400000) return false;
      return true;
    }

    chooseRoom(room) {
      if (this.tags) this.tags.value = 'newsletter, Aaronya room offer, Room: ' + room;
      if (this.selection) this.selection.textContent = room;
      this.showStep('email');
      window.setTimeout(() => this.email?.focus(), 80);
    }

    showStep(name) {
      this.steps.forEach((step) => {
        step.hidden = step.dataset.roomOfferStep !== name;
      });
    }

    open() {
      if (this.triggered || this.dialog.open) return;

      this.triggered = true;
      window.clearTimeout(this.openTimer);
      window.removeEventListener('scroll', this.scrollHandler);
      this.writeStorage(this.sessionKey, 'true');
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.querySelector('[data-room-choice]')?.focus();
    }

    closeOffer() {
      if (!this.dialog.open) return;

      this.rememberDismissal();
      this.dialog.close();
      this.dialog.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }

    rememberDismissal() {
      const completed = !this.querySelector('[data-room-offer-step="success"]')?.hidden;
      this.writeStorage(completed ? this.successKey : this.dismissKey, Date.now());
    }

    async copyCode(button) {
      try {
        await navigator.clipboard.writeText('CANVAS15');
        const label = button.querySelector('[data-room-offer-copy-label]');
        const status = this.querySelector('[data-room-offer-copy-status]');
        if (label) label.textContent = button.dataset.copiedLabel;
        if (status) status.textContent = button.dataset.copiedLabel;
      } catch (error) {
        const status = this.querySelector('[data-room-offer-copy-status]');
        if (status) status.textContent = 'CANVAS15';
      }
    }

    readStorage(key) {
      try {
        return window.localStorage.getItem(key) || window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    writeStorage(key, value) {
      try {
        if (key === this.sessionKey) {
          window.sessionStorage.setItem(key, String(value));
          return;
        }
        window.localStorage.setItem(key, String(value));
      } catch (error) {
        return;
      }
    }
  }

  if (!customElements.get('aaronya-room-offer')) {
    customElements.define('aaronya-room-offer', AaronyaRoomOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canvas-room-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('canvas-room-viewer')) {
    class CanvasRoomGeometry {
      static dimensions(title) {
        const m=String(title).match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×✕]\s*(\d+(?:\.\d+)?)/i);
        if (!m) return null;
        const w=Number(m[1]),h=Number(m[2]);
        if (!(w>0 && h>0 && w<300 && h<300)) return null;
        return {width:w*0.0254,height:h*0.0254,label:`${w} × ${h} in`,depth:0.0254};
      }
      static faces(size) {
        const x=size.width/2,y=size.height/2,z=size.depth;
        return [
          {p:[[-x,-y,z],[x,-y,z],[x,y,z],[-x,y,z]],n:[0,0,1],uv:[[0,0],[1,0],[1,1],[0,1]]},
          {p:[[x,-y,0],[-x,-y,0],[-x,y,0],[x,y,0]],n:[0,0,-1],uv:[[0,0],[1,0],[1,1],[0,1]],back:true},
          {p:[[-x,-y,0],[-x,-y,z],[-x,y,z],[-x,y,0]],n:[-1,0,0],uv:[[.06,0],[0,0],[0,1],[.06,1]]},
          {p:[[x,-y,z],[x,-y,0],[x,y,0],[x,y,z]],n:[1,0,0],uv:[[1,0],[.94,0],[.94,1],[1,1]]},
          {p:[[-x,y,z],[x,y,z],[x,y,0],[-x,y,0]],n:[0,1,0],uv:[[0,1],[1,1],[1,.94],[0,.94]]},
          {p:[[-x,-y,0],[x,-y,0],[x,-y,z],[-x,-y,z]],n:[0,-1,0],uv:[[0,.06],[1,.06],[1,0],[0,0]]}
        ];
      }
      static crc(bytes) {
        let crc=0xffffffff;
        for (const byte of bytes) { crc^=byte; for(let i=0;i<8;i++) crc=(crc>>>1)^((crc&1)?0xedb88320:0); }
        return (crc^0xffffffff)>>>0;
      }
      static zip(files) {
        const enc=new TextEncoder(),chunks=[],central=[]; let offset=0;
        for(const file of files) {
          const name=enc.encode(file.name),data=file.data,crc=this.crc(data);
          const extra=4+((64-(offset+30+name.length+4)%64)%64);
          const header=new Uint8Array(30+name.length+extra),v=new DataView(header.buffer);
          v.setUint32(0,0x04034b50,true);v.setUint16(4,20,true);v.setUint32(14,crc,true);v.setUint32(18,data.length,true);v.setUint32(22,data.length,true);v.setUint16(26,name.length,true);v.setUint16(28,extra,true);
          header.set(name,30);v.setUint16(30+name.length,0x1986,true);v.setUint16(32+name.length,extra-4,true);
          const entry=new Uint8Array(46+name.length),c=new DataView(entry.buffer);
          c.setUint32(0,0x02014b50,true);c.setUint16(4,20,true);c.setUint16(6,20,true);c.setUint32(16,crc,true);c.setUint32(20,data.length,true);c.setUint32(24,data.length,true);c.setUint16(28,name.length,true);c.setUint32(42,offset,true);entry.set(name,46);
          chunks.push(header,data);central.push(entry);offset+=header.length+data.length;
        }
        const length=central.reduce((n,c)=>n+c.length,0),end=new Uint8Array(22),v=new DataView(end.buffer);
        v.setUint32(0,0x06054b50,true);v.setUint16(8,files.length,true);v.setUint16(10,files.length,true);v.setUint32(12,length,true);v.setUint32(16,offset,true);
        const result=new Uint8Array(offset+length+22);let i=0;for(const chunk of [...chunks,...central,end]){result.set(chunk,i);i+=chunk.length;}return result;
      }
      static usd(size) {
        const tuple=a=>`(${a.map(n=>Number(n.toFixed(8))).join(', ')})`;
        let meshes='';
        this.faces(size).forEach((face,i)=>{
          meshes+=`def Mesh "Face${i}" (prepend apiSchemas = ["MaterialBindingAPI"]) {
            int[] faceVertexCounts = [4]
            int[] faceVertexIndices = [0, 1, 2, 3]
            point3f[] points = [${face.p.map(p=>tuple([p[0],p[2],-p[1]])).join(',')}]
            normal3f[] normals = [${tuple([face.n[0],face.n[2],-face.n[1]])}] (interpolation = "uniform")
            texCoord2f[] primvars:st = [${face.uv.map(tuple).join(',')}] (interpolation = "vertex")
            uniform token subdivisionScheme = "none"
            rel material:binding = </Canvas/${face.back?'Backing':'Artwork'}>
          }\n`;
        });
        return `#usda 1.0
        (defaultPrim = "Canvas"\n metersPerUnit = 1\n upAxis = "Y")
        def Xform "Canvas" (prepend apiSchemas = ["Preliminary_AnchoringAPI"]) {
          uniform token preliminary:anchoring:type = "plane"
          uniform token preliminary:planeAnchoring:alignment = "vertical"
          ${meshes}
          def Material "Artwork" {
            token outputs:surface.connect = </Canvas/Artwork/Surface.outputs:surface>
            def Shader "Surface" { uniform token info:id = "UsdPreviewSurface"\n color3f inputs:diffuseColor.connect = </Canvas/Artwork/Texture.outputs:rgb>\n float inputs:roughness = 0.9\n float inputs:metallic = 0\n token outputs:surface\n }
            def Shader "UV" { uniform token info:id = "UsdPrimvarReader_float2"\n token inputs:varname = "st"\n float2 outputs:result\n }
            def Shader "Texture" { uniform token info:id = "UsdUVTexture"\n asset inputs:file = @artwork.jpeg@\n token inputs:sourceColorSpace = "sRGB"\n float2 inputs:st.connect = </Canvas/Artwork/UV.outputs:result>\n token inputs:wrapS = "clamp"\n token inputs:wrapT = "clamp"\n float3 outputs:rgb\n }
          }
          def Material "Backing" {
            token outputs:surface.connect = </Canvas/Backing/Surface.outputs:surface>
            def Shader "Surface" { uniform token info:id = "UsdPreviewSurface"\n color3f inputs:diffuseColor = (0.56, 0.46, 0.31)\n float inputs:roughness = 1\n token outputs:surface\n }
          }
        }`;
      }
      static multiply(a,b) {
        const out=new Float32Array(16);
        for(let c=0;c<4;c++)for(let r=0;r<4;r++)for(let k=0;k<4;k++)out[c*4+r]+=a[k*4+r]*b[c*4+k];return out;
      }
      static wall(matrix,camera) {
        if(Math.abs(matrix[5])>.45) return null;
        let nx=matrix[4],nz=matrix[6],length=Math.hypot(nx,nz);if(length<.5)return null;
        nx/=length;nz/=length;
        if(nx*(camera.x-matrix[12])+nz*(camera.z-matrix[14])<0){nx=-nx;nz=-nz;}
        return new Float32Array([nz,0,-nx,0,0,1,0,0,nx,0,nz,0,matrix[12]+nx*.003,matrix[13],matrix[14]+nz*.003,1]);
      }
    }
    class CanvasRoomRenderer {
      constructor(canvas,source) {
        this.canvas=canvas;const gl=this.gl=canvas.getContext('webgl',{alpha:true,antialias:true,xrCompatible:true});if(!gl)throw new Error('WebGL unavailable');
        const shader=(type,source)=>{const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(s));return s;};
        const vertex=shader(gl.VERTEX_SHADER,'attribute vec3 p;attribute vec3 n;attribute vec2 uv;attribute float back;uniform mat4 mvp;varying vec2 vUV;varying float vLight;varying float vBack;void main(){gl_Position=mvp*vec4(p,1.);vUV=uv;vLight=.82+.18*max(dot(n,normalize(vec3(-.4,.7,1.))),0.);vBack=back;}');
        const fragment=shader(gl.FRAGMENT_SHADER,'precision mediump float;uniform sampler2D art;varying vec2 vUV;varying float vLight;varying float vBack;void main(){vec3 color=vBack>.5?vec3(.69,.59,.43):texture2D(art,vUV).rgb;gl_FragColor=vec4(color*vLight,1.);}');
        this.program=gl.createProgram();gl.attachShader(this.program,vertex);gl.attachShader(this.program,fragment);gl.linkProgram(this.program);if(!gl.getProgramParameter(this.program,gl.LINK_STATUS))throw new Error('Shader link failed');gl.deleteShader(vertex);gl.deleteShader(fragment);
        this.buffer=gl.createBuffer();this.texture=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,source);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
      }
      geometry(size) {
        const data=[];for(const f of CanvasRoomGeometry.faces(size))for(const i of [0,1,2,0,2,3])data.push(...f.p[i],...f.n,...f.uv[i],f.back?1:0);
        const gl=this.gl;gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(data),gl.STATIC_DRAW);
      }
      draw(mvp) {
        const gl=this.gl;gl.useProgram(this.program);gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);
        for(const [name,size,offset] of [['p',3,0],['n',3,12],['uv',2,24],['back',1,32]]){const a=gl.getAttribLocation(this.program,name);gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,size,gl.FLOAT,false,36,offset);}
        gl.activeTexture(gl.TEXTURE0);gl.bindTexture(gl.TEXTURE_2D,this.texture);gl.uniform1i(gl.getUniformLocation(this.program,'art'),0);gl.uniformMatrix4fv(gl.getUniformLocation(this.program,'mvp'),false,mvp);gl.enable(gl.DEPTH_TEST);gl.enable(gl.CULL_FACE);gl.cullFace(gl.BACK);gl.drawArrays(gl.TRIANGLES,0,36);
      }
      preview(size) {
        const gl=this.gl,c=this.canvas;c.width=Math.max(1,c.clientWidth*devicePixelRatio);c.height=Math.max(1,c.clientHeight*devicePixelRatio);gl.bindFramebuffer(gl.FRAMEBUFFER,null);gl.viewport(0,0,c.width,c.height);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
        const aspect=c.width/c.height,span=Math.max(size.height*1.35,size.width*1.35/aspect),x=span*aspect/2,y=span/2;
        const projection=new Float32Array([1/x,0,0,0,0,1/y,0,0,0,0,-.5,0,0,0,0,1]);
        const a=-.3,model=new Float32Array([Math.cos(a),0,-Math.sin(a),0,0,1,0,0,Math.sin(a),0,Math.cos(a),0,0,0,-1,1]);
        this.geometry(size);this.draw(CanvasRoomGeometry.multiply(projection,model));
      }
      dispose(){const gl=this.gl;gl.deleteBuffer(this.buffer);gl.deleteTexture(this.texture);gl.deleteProgram(this.program);}
    }
    customElements.define('canvas-room-viewer',class extends HTMLElement {
      connectedCallback() {
        if(this.ready)return;this.ready=true;
        this.dialog=this.querySelector('dialog');this.overlay=this.querySelector('.canvas-room__overlay');this.select=this.querySelector('[data-size]');this.xrSelect=this.querySelector('[data-xr-size]');this.strings=JSON.parse(this.querySelector('[data-strings]').textContent);
        const variants=JSON.parse(this.querySelector('[data-variants]').textContent),seen=new Set();this.sizes=[];
        const namedCanvas=variants.some(v=>/canvas/i.test(v.title));
        for(const variant of variants){if(namedCanvas&&!/canvas/i.test(variant.title))continue;const size=CanvasRoomGeometry.dimensions(variant.title);if(size&&!seen.has(size.label)){seen.add(size.label);this.sizes.push(size);}}
        if(!this.sizes.length){this.querySelector('[data-open]').hidden=true;return;}
        const mobile=/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
        this.querySelector('[data-open]').hidden=!mobile;
        for(const s of this.sizes)for(const select of [this.select,this.xrSelect]){const o=document.createElement('option');o.value=s.label;o.textContent=s.label;select.append(o);}
        this.querySelector('[data-open]').addEventListener('click',()=>this.open());
        this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
        this.dialog.addEventListener('close',()=>{this.querySelector('[data-open]').focus();});
        this.select.addEventListener('change',()=>this.choose(this.select.value));this.xrSelect.addEventListener('change',()=>this.choose(this.xrSelect.value));
        this.querySelector('[data-launch]').addEventListener('click',()=>this.startXR());
        this.querySelector('[data-exit]').addEventListener('click',()=>this.session?.end());
        this.querySelector('[data-place]').addEventListener('click',()=>this.place());
        this.querySelector('[data-reposition]').addEventListener('click',()=>{this.placed=null;this.querySelector('[data-place]').hidden=false;this.querySelector('[data-reposition]').hidden=true;});
        this.overlay.addEventListener('beforexrselect',event=>{if(event.target.closest('button,select,label'))event.preventDefault();});
        this.resize=new ResizeObserver(()=>{if(this.renderer&&this.size&&!this.session)this.renderer.preview(this.size);});this.resize.observe(this.querySelector('[data-render]'));
      }
      disconnectedCallback(){this.session?.end();this.resize?.disconnect();this.renderer?.dispose();if(this.objectURL)URL.revokeObjectURL(this.objectURL);}
      status(key){this.querySelector('[data-status]').textContent=this.strings[key];}
      async open(){
        this.spin=this.closest('canvas-spin-preview');this.spin?.takeControl();this.dialog.showModal();this.status('loading');
        try {
          const controls=this.spin.productRoot?.querySelectorAll('variant-picker input:checked,variant-picker select');let selected=CanvasRoomGeometry.dimensions(this.dataset.selected);
          for(const control of controls||[]){const s=CanvasRoomGeometry.dimensions(control.value);if(s)selected=s;}
          this.size=this.sizes.find(s=>s.label===selected?.label)||this.sizes[0];this.select.value=this.xrSelect.value=this.size.label;
          this.source=await this.spin.loadArtwork();
          if(!this.renderer)this.renderer=new CanvasRoomRenderer(this.querySelector('[data-render]'),this.source);
          const link=document.createElement('a');this.ios=!!link.relList?.supports?.('ar')&&(/iPhone|iPad|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1));
          this.webxr=!!navigator.xr&&await navigator.xr.isSessionSupported('immersive-ar').catch(()=>false);
          await this.choose(this.size.label);
        }catch(error){this.status('error');}
      }
      async choose(label){
        this.size=this.sizes.find(s=>s.label===label)||this.sizes[0];this.select.value=this.xrSelect.value=this.size.label;this.querySelector('[data-measure]').textContent=this.size.label;
        if(this.session){this.xrRenderer.geometry(this.size);return;}
        this.renderer?.preview(this.size);
        this.querySelector('[data-launch]').hidden=!this.webxr;const link=this.querySelector('[data-quicklook]');link.hidden=true;
        if(this.webxr){this.status('ready');return;}
        if(!this.ios){this.status('unsupported');return;}
        this.status('loading');const revision=this.revision=(this.revision||0)+1;
        try{
          const c=document.createElement('canvas');c.width=this.source.naturalWidth||this.source.width;c.height=this.source.naturalHeight||this.source.height;c.getContext('2d').drawImage(this.source,0,0);
          const jpeg=await new Promise(resolve=>c.toBlob(resolve,'image/jpeg',.92));if(!jpeg)throw new Error('Texture unavailable');
          const bytes=CanvasRoomGeometry.zip([{name:'canvas.usda',data:new TextEncoder().encode(CanvasRoomGeometry.usd(this.size))},{name:'artwork.jpeg',data:new Uint8Array(await jpeg.arrayBuffer())}]);
          if(revision!==this.revision)return;if(this.objectURL)URL.revokeObjectURL(this.objectURL);this.objectURL=URL.createObjectURL(new Blob([bytes],{type:'model/vnd.usdz+zip'}));link.href=this.objectURL+'#allowsContentScaling=0';link.hidden=false;this.status('ios');
        }catch(error){this.status('error');}
      }
      place(){if(!this.candidate)return;this.placed=new Float32Array(this.candidate);this.querySelector('[data-place]').hidden=true;this.querySelector('[data-reposition]').hidden=false;this.querySelector('[data-xr-status]').textContent=this.strings.placed;}
      async startXR(){
        if(this.session)return;
        try{
          const pending=navigator.xr.requestSession('immersive-ar',{requiredFeatures:['local','hit-test','dom-overlay'],domOverlay:{root:this.overlay},optionalFeatures:['light-estimation']});
          this.session=await pending;const session=this.session;this.dialog.close();this.overlay.hidden=false;this.placed=null;this.candidate=null;
          this.querySelector('[data-place]').hidden=false;this.querySelector('[data-place]').disabled=true;this.querySelector('[data-reposition]').hidden=true;this.querySelector('[data-xr-status]').textContent=this.strings.scan;
          session.addEventListener('end',()=>this.endXR(),{once:true});
          this.xrRenderer=new CanvasRoomRenderer(document.createElement('canvas'),this.source);const gl=this.xrRenderer.gl;await gl.makeXRCompatible();
          session.updateRenderState({baseLayer:new XRWebGLLayer(session,gl,{alpha:true})});
          this.space=await session.requestReferenceSpace('local');const viewer=await session.requestReferenceSpace('viewer');this.hit=await session.requestHitTestSource({space:viewer});this.xrRenderer.geometry(this.size);
          session.addEventListener('select',()=>{if(!this.placed)this.place();});
          const frame=(time,frame)=>{
            if(this.session!==session)return;session.requestAnimationFrame(frameCallback);const pose=frame.getViewerPose(this.space);if(!pose){gl.bindFramebuffer(gl.FRAMEBUFFER,session.renderState.baseLayer.framebuffer);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);this.candidate=null;this.querySelector('[data-place]').disabled=true;this.querySelector('[data-xr-status]').textContent=this.strings.tracking;return;}
            if(!this.placed){this.candidate=null;for(const hit of frame.getHitTestResults(this.hit)){const p=hit.getPose(this.space);if(p){const wall=CanvasRoomGeometry.wall(p.transform.matrix,pose.transform.position);if(wall){this.candidate=wall;break;}}}this.querySelector('[data-place]').disabled=!this.candidate;this.querySelector('[data-xr-status]').textContent=this.strings[this.candidate?'found':'scan'];}
            const layer=session.renderState.baseLayer;gl.bindFramebuffer(gl.FRAMEBUFFER,layer.framebuffer);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);const model=this.placed||this.candidate;if(!model)return;
            for(const view of pose.views){const viewport=layer.getViewport(view);gl.viewport(viewport.x,viewport.y,viewport.width,viewport.height);this.xrRenderer.draw(CanvasRoomGeometry.multiply(view.projectionMatrix,CanvasRoomGeometry.multiply(view.transform.inverse.matrix,model)));}
          };
          const frameCallback=frame;session.requestAnimationFrame(frameCallback);
        }catch(error){if(this.session)await this.session.end().catch(()=>{});this.session=null;this.overlay.hidden=true;if(!this.dialog.open)this.dialog.showModal();this.status('error');}
      }
      endXR(){this.hit?.cancel();this.hit=null;this.xrRenderer?.dispose();this.xrRenderer=null;this.session=null;this.overlay.hidden=true;if(this.isConnected){this.dialog.showModal();this.renderer?.preview(this.size);this.status('ready');}}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["canvas-spin-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('canvas-spin-preview')) {
    customElements.define('canvas-spin-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) { this.resize.observe(this.stage); this.visibility.observe(this.stage); this.startSpin(); return; }
        this.ready = true;
        this.y = -24;
        this.x = -8;
        this.stage = this.querySelector('.canvas-spin__stage');
        this.model = this.querySelector('.canvas-spin__model');
        this.ratio = Number(this.dataset.ratio) || 1;
        this.sizeRatio = this.parseSize(this.dataset.size);
        this.productRoot = this.closest('product-component') || this.closest('.shopify-section');
        this.onSizeChange = () => requestAnimationFrame(() => this.updateSize());
        this.productRoot?.addEventListener('change', this.onSizeChange);
        this.sizeObserver = new MutationObserver(() => this.updateSize());
        const picker = this.productRoot?.querySelector('variant-picker');
        if (picker) this.sizeObserver.observe(picker, {childList:true,subtree:true});
        this.resize = new ResizeObserver(() => this.fit());
        this.resize.observe(this.stage);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.startSpin();
        });
        this.visibility.observe(this.stage);
        this.motion.addEventListener('change', () => this.startSpin());
        this.stage.addEventListener('focusin', () => this.takeControl());
        this.querySelector('details').addEventListener('toggle', () => {
          this.fit();
          if (!this.loaded && this.querySelector('details').open) { this.loaded = true; this.loadArtwork().catch(() => { this.loaded = false; }); }
          this.startSpin();
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          this.takeControl();
          if (button.hasAttribute('data-reset')) { this.y = -24; this.x = -8; }
          else this.y += Number(button.dataset.turn) || 0;
          this.paint();
        });
        this.stage.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home'].includes(event.key)) return;
          event.preventDefault();
          this.takeControl();
          if (event.key === 'Home') { this.y = -24; this.x = -8; }
          else if (event.key === 'ArrowLeft') this.y -= 15;
          else if (event.key === 'ArrowRight') this.y += 15;
          else this.x = Math.max(-65, Math.min(65, this.x + (event.key === 'ArrowUp' ? -10 : 10)));
          this.paint();
        });
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.takeControl();
          this.pointer = event.pointerId;
          this.lastX = event.clientX;
          this.stage.setPointerCapture(event.pointerId);
          this.stage.dataset.dragging = '';
        });
        this.stage.addEventListener('pointermove', event => {
          if (this.pointer !== event.pointerId) return;
          this.y += (event.clientX - this.lastX) * 0.65;
          this.lastX = event.clientX;
          this.paint();
        });
        const stop = () => { this.pointer = null; delete this.stage.dataset.dragging; };
        this.stage.addEventListener('pointerup', stop);
        this.stage.addEventListener('pointercancel', stop);
        this.stage.addEventListener('lostpointercapture', stop);
      }
      disconnectedCallback() { this.resize?.disconnect(); this.visibility?.disconnect(); cancelAnimationFrame(this.frame); }
      takeControl() { this.interacted = true; cancelAnimationFrame(this.frame); }
      startSpin() {
        cancelAnimationFrame(this.frame);
        if (this.interacted || this.motion.matches || !this.visible || !this.querySelector('details').open || !this.isConnected) return;
        this.lastTime = null;
        const tick = time => {
          if (this.lastTime !== null) this.y += Math.min(time - this.lastTime, 50) * 0.024;
          this.lastTime = time;
          this.paint();
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      fit() {
        const ratio = this.sizeRatio || this.ratio;
        const maxWidth = Math.min(290, this.stage.clientWidth * 0.7);
        const maxHeight = this.stage.clientHeight * 0.7;
        const width = Math.min(maxWidth, maxHeight * ratio);
        this.model.style.setProperty('--w', `${width}px`);
        this.model.style.setProperty('--h', `${width / ratio}px`);
      }
      parseSize(value) {
        const match = String(value || '').match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×✕]\s*(\d+(?:\.\d+)?)/i);
        if (!match) return null;
        const ratio = Number(match[1]) / Number(match[2]);
        return ratio > 0 && Number.isFinite(ratio) ? ratio : null;
      }
      updateSize() {
        const controls = this.productRoot?.querySelectorAll('variant-picker input:checked, variant-picker select');
        for (const control of controls || []) {
          const ratio = this.parseSize(control.value);
          if (ratio) { this.sizeRatio = ratio; this.fit(); break; }
        }
      }
      paint() { this.model.style.transform = `rotateX(${this.x}deg) rotateY(${this.y}deg)`; }
      loadArtwork() {
        if (this.artworkReady) return this.artworkReady;
        this.artworkReady = new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          this.artworkTexture = image;
          try {
          this.wrapEdges(image);
          if (this.dataset.crop !== 'true') return;
          try {
            const canvas = document.createElement('canvas');
            canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
            const ctx = canvas.getContext('2d', {willReadFrequently:true});
            ctx.drawImage(image,0,0);
            const {data} = ctx.getImageData(0,0,canvas.width,canvas.height);
            const w = canvas.width, h = canvas.height;
            const pale = (x,y) => { const i=(y*w+x)*4; return data[i+3]<30 || Math.min(data[i],data[i+1],data[i+2])>225; };
            let borderSamples=0, paleSamples=0;
            for(let x=0;x<w;x+=8) for(const y of [0,h-1]) { borderSamples++; if(pale(x,y)) paleSamples++; }
            for(let y=0;y<h;y+=8) for(const x of [0,w-1]) { borderSamples++; if(pale(x,y)) paleSamples++; }
            if(paleSamples/borderSamples<0.9) return;
            const dark = (x,y) => { const i = (y*w+x)*4; return data[i+3]>200 && Math.min(data[i],data[i+1],data[i+2])<190; };
            const xs=[], ys=[];
            for(let x=0;x<w;x++){ let count=0; for(let y=0;y<h;y+=4) if(dark(x,y)) count++; if(count>h*0.05) xs.push(x); }
            for(let y=0;y<h;y++){ let count=0; for(let x=0;x<w;x+=4) if(dark(x,y)) count++; if(count>w*0.05) ys.push(y); }
            if(!xs.length || !ys.length) return;
            const left=xs[0], top=ys[0], width=xs.at(-1)-left+1, height=ys.at(-1)-top+1;
            if(width<w*0.2 || height<h*0.2) return;
            const marginX=(w-width)/w, marginY=(h-height)/h;
            if(marginX<0.04 || marginY<0.04) return;
            const trim=Math.round(Math.min(width,height)*0.028);
            const output=document.createElement('canvas'); output.width=width-2*trim; output.height=height-2*trim;
            output.getContext('2d').drawImage(image,left+trim,top+trim,output.width,output.height,0,0,output.width,output.height);
            const front=this.querySelector('.canvas-spin__front img');
            front.removeAttribute('srcset'); front.src=output.toDataURL('image/jpeg',0.92);
            this.artworkTexture = output;
            this.wrapEdges(output);
            this.ratio=output.width/output.height; this.fit();
          } catch(error) { this.fit(); }
          } finally { resolve(this.artworkTexture); }
        };
        image.onerror = () => { this.artworkReady = null; reject(new Error('Artwork could not load')); };
        image.src=this.dataset.image;
        });
        return this.artworkReady;
      }
      wrapEdges(source) {
        try {
          const w=source.naturalWidth || source.width, h=source.naturalHeight || source.height;
          const sw=Math.max(1,Math.round(w*0.06)), sh=Math.max(1,Math.round(h*0.06));
          for (const [side,x,y,width,height,horizontal] of [
            ['left',0,0,sw,h,true],['right',w-sw,0,sw,h,true],
            ['top',0,0,w,sh,false],['bottom',0,h-sh,w,sh,false]
          ]) {
            const texture=document.createElement('canvas'); texture.width=width; texture.height=height;
            const ctx=texture.getContext('2d');
            ctx.translate(horizontal ? width : 0,horizontal ? 0 : height);
            ctx.scale(horizontal ? -1 : 1,horizontal ? 1 : -1);
            ctx.drawImage(source,x,y,width,height,0,0,width,height);
            this.querySelector(`.canvas-spin__${side}`).style.backgroundImage=`url("${texture.toDataURL('image/jpeg',0.92)}")`;
          }
        } catch(error) { }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class AaronyaPricePresets extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.updatePressedState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-min][data-max]');
      if (!(button instanceof HTMLButtonElement)) return;
      const facet = this.closest('price-facet-component');
      if (!facet) return;
      const minInput = facet.querySelector('[ref="minInput"]');
      const maxInput = facet.querySelector('[ref="maxInput"]');
      if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;
      minInput.value = button.dataset.min || '';
      maxInput.value = button.dataset.max || '';
      this.updatePressedState();
      facet.updatePriceFilterAndResults();
    };

    updatePressedState() {
      const facet = this.closest('price-facet-component');
      const minInput = facet?.querySelector('[ref="minInput"]');
      const maxInput = facet?.querySelector('[ref="maxInput"]');
      if (!(minInput instanceof HTMLInputElement) || !(maxInput instanceof HTMLInputElement)) return;
      this.querySelectorAll('[data-min][data-max]').forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;
        button.setAttribute(
          'aria-pressed',
          String((button.dataset.min || '') === minInput.value && (button.dataset.max || '') === maxInput.value)
        );
      });
    }
  }

  if (!customElements.get('aaronya-price-presets')) {
    customElements.define('aaronya-price-presets', AaronyaPricePresets);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["print-format-comparison"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('print-format-comparison')) {
    customElements.define('print-format-comparison',class extends HTMLElement {
      async connectedCallback() {
        await customElements.whenDefined('canvas-spin-preview');
        if(!this.isConnected)return;
        if(this.observer){this.observer.observe(this);this.resize.observe(this);document.addEventListener('visibilitychange',this.onVisibility);this.motion.addEventListener('change',this.onMotion);return;}
        this.spin=this.closest('.shopify-section').querySelector('canvas-spin-preview');this.items=[...this.querySelectorAll('[data-format]')];
        this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;
        this.button=this.querySelector('[data-format-pause]');
        this.button.addEventListener('click',()=>{this.paused=!this.paused;for(const item of this.items){const model=item.querySelector('.canvas-spin__model');if(model)model.style.removeProperty('animation');}this.running();});
        this.onMotion=()=>{this.paused=this.motion.matches;this.running();};this.motion.addEventListener('change',this.onMotion);
        this.onVisibility=()=>this.running();document.addEventListener('visibilitychange',this.onVisibility);
        const titles=JSON.parse(this.querySelector('[data-format-variants]').textContent);
        for(const item of this.items){const sizes=[...new Set(titles.filter(t=>t.toLowerCase().includes(item.dataset.format)).map(t=>t.match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×✕]\s*(\d+(?:\.\d+)?)/i)).filter(Boolean).map(m=>`${m[1]} × ${m[2]}″`))];item.querySelector('[data-format-sizes]').textContent=sizes.join(' · ');item.ratio=this.spin.parseSize(sizes[0])||1;this.bindStage(item);}
        this.resize=new ResizeObserver(()=>this.fit());this.resize.observe(this);
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible)this.load();this.running();},{threshold:0.05});this.observer.observe(this);this.running();
      }
      disconnectedCallback(){this.observer?.disconnect();this.resize?.disconnect();this.removeAttribute('data-running');document.removeEventListener('visibilitychange',this.onVisibility);this.motion?.removeEventListener('change',this.onMotion);}
      async load(){
        if(this.loading||this.loaded)return;this.loading=true;
        try{await customElements.whenDefined('canvas-spin-preview');await this.spin.loadArtwork();if(!this.isConnected){this.loading=false;return;}
          for(const item of this.items){const model=this.spin.model.cloneNode(true);model.removeAttribute('style');model.setAttribute('aria-hidden','true');model.style.setProperty('--d',item.dataset.format==='poster'?'1px':'12px');item.querySelector('.format-compare__stage').append(model);}
          this.loaded=true;this.fit();this.running();
        }catch(error){this.querySelector('[data-format-error]').hidden=false;this.button.hidden=true;}finally{this.loading=false;}
      }
      fit(){for(const item of this.items){const stage=item.querySelector('.format-compare__stage'),model=stage.querySelector('.canvas-spin__model');if(!model)continue;const w=Math.min(230,stage.clientWidth*.68,stage.clientHeight*.68*item.ratio);model.style.setProperty('--w',`${w}px`);model.style.setProperty('--h',`${w/item.ratio}px`);}}
      running(){this.toggleAttribute('data-running',!!this.loaded&&this.visible&&!this.paused&&!document.hidden);this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.pause;}
      bindStage(item){
        const stage=item.querySelector('.format-compare__stage');let drag=null;
        const stop=()=>{this.paused=true;this.running();};
        stage.addEventListener('pointerdown',e=>{const model=stage.querySelector('.canvas-spin__model');if(!model)return;stop();drag={x:e.clientX,base:getComputedStyle(model).transform,model};model.style.animation='none';model.style.transform=drag.base;stage.setPointerCapture(e.pointerId);});
        stage.addEventListener('pointermove',e=>{if(drag)drag.model.style.transform=`${drag.base} rotateY(${(e.clientX-drag.x)*.7}deg)`;});
        for(const event of ['pointerup','pointercancel','lostpointercapture'])stage.addEventListener(event,()=>{drag=null;});
        stage.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const model=stage.querySelector('.canvas-spin__model');if(!model)return;stop();const base=getComputedStyle(model).transform;model.style.animation='none';model.style.transform=`${base} rotateY(${e.key==='ArrowLeft'?-25:25}deg)`;});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-guide-open]');
    const closeButton = event.target.closest('[data-size-guide-close]');

    if (openButton) {
      document.getElementById(openButton.getAttribute('aria-controls'))?.showModal();
    }

    if (closeButton) {
      closeButton.closest('dialog')?.close();
    }

    if (event.target instanceof HTMLDialogElement && event.target.matches('.variant-picker__size-guide-dialog')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
